import { FormValidation } from './formValidation'

export class FormValidationBuilder {
  private static forms: Map<string, FormValidation> = new Map<string, FormValidation>()
  public static build(formKey: string) {
    if (FormValidationBuilder.forms.has(formKey)) {
      return FormValidationBuilder.forms.get(formKey)!
    } else {
      const form = new FormValidation()
      FormValidationBuilder.forms.set(formKey, form)
      return form
    }
  }
}
